import CircularProgress from '@mui/material/CircularProgress'

interface ILoadingSpinner {
  isLoading: boolean
  children: React.ReactNode
}

const Spinner = () => (
  <div
    data-testid='spinner'
    className='absolute inset-0 z-10 flex h-full w-full bg-white bg-opacity-75'
  >
    <CircularProgress className='m-auto' size='5rem' />
  </div>
)

const SpinnerOverlay = ({ children }: React.PropsWithChildren) => (
  <div className='relative flex-1 overflow-auto'>{children}</div>
)

const LoadingSpinner = ({ children, isLoading }: ILoadingSpinner) => {
  // NOTE: try height 100% inside instead of flex due to relative display
  return (
    <SpinnerOverlay>
      {isLoading ? <Spinner /> : null}
      {children}
    </SpinnerOverlay>
  )
}

export const SpinnerWithOverlay = () => (
  <SpinnerOverlay>
    <Spinner />
  </SpinnerOverlay>
)

export default LoadingSpinner
